export const TAX_FORM_TYPES = {
    W_2G: 'W-2G Tax Forms',
    NET_WIN_LOSS: 'Net Win/Loss Statement'
};

export const W_2G_TAX_FORMS = {
    CASINO: 'Casino W-2G Tax Forms',
    SPORTSBOOK: 'Sportsbook W-2G Tax Forms'
};
